import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  SimpleChanges,
  EventEmitter,
  Output,
  ViewChild,
  Inject,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  FormControl,
  Validators 
} from '@angular/forms';

import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { isEqual, isNil } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil, mergeMap, shareReplay } from 'rxjs/operators';
import { DatexFormControl, validateControlOnChange, validateFormOnControlChange } from './models/datex-form-control';
import { TabItemModel, TabGroupModel } from './models/tab';
import { WidgetModel } from './models/widget';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles,
  ValueControlModel
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { FieldsetModel } from './models/fieldset';
import { ToolModel } from './models/tool';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { Lots_ShellService } from './Lots.shell.service';
import { Lots_OperationService } from './Lots.operation.service';
import { Lots_DatasourceService } from './Lots.datasource.index';
import { Lots_FlowService } from './Lots.flow.index';
import { Lots_ReportService } from './Lots.report.index';
import { Lots_LocalizationService } from './Lots.localization.service';
import { Lots_lot_status_change_editor_ComponentContextService } from './Lots.lot_status_change_editor.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './Lots.frontend.types'
import { $frontendTypes as $types} from './Lots.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

import { Lots_lot_statuses_dd_singleComponent } from './Lots.lot_statuses_dd_single.component'
import { Lots_reason_codes_multiComponent } from './Lots.reason_codes_multi.component'

type EntityType = { 
    Id?: number, Description?: string, LookupCode?: string, MaterialId?: number, Notes?: string, StatusId?: number, VendorLot?: { Id?: number, Description?: string, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, Vat?: string }, Status?: { Name?: string }, Material?: { ProjectId?: number }}; 

@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => Lots_lot_statuses_dd_singleComponent),
    forwardRef(() => Lots_reason_codes_multiComponent),
  ],
  selector: 'Lots-lot_status_change_editor',
  templateUrl: './Lots.lot_status_change_editor.component.html'
})
export class Lots_lot_status_change_editorComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {
  inParams: { lotId: number } = { lotId: null };
  //#region Inputs
  @Input('lotId') set $inParams_lotId(v: number) {
    this.inParams.lotId = v;
  }
  get $inParams_lotId(): number {
    return this.inParams.lotId;
  }
  //#endregion Inputs

  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  outParams: { confirm?: boolean } = { confirm: null };
  //#endregion Outputs

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  //#endregion
  entity: EntityType;

  formGroup: FormGroup = new FormGroup({
    status: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    reason_codes: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });
  
  get valid(): boolean {
    return this.formGroup.valid;
  }

  toolbar = {
      confirm: new ToolModel(new ButtonModel('confirm', new ButtonStyles(['primary'], null), false, false, false, 'Change status', '', null)
    , false),
      cancel: new ToolModel(new ButtonModel('cancel', new ButtonStyles(['secondary'], null), false, false, false, 'Cancel', '', null)
    , false)
  };

  fields = {
    text: new FieldModel(new TextModel(null, null, null, null, null)
, new ControlContainerStyles(null, null), 'All inventory for the lot will be put on hold.', false, false),
    status: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['status'] as DatexFormControl, 
  null, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'New status', false, false),
    reason_codes: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['reason_codes'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Reason for status change', false, false),
  };

  fieldsets = {
    newGroup2: new FieldsetModel(
      ' ',
      true,
      false,
      true,
      false,
        null
      ,
      () => {
        const $editor = this;
        const $utils = this.$utils;
        return '';
      }
    ),
};


  //#region fields inParams
  //#endregion fields inParams

  $formGroupFieldValidationObservables = {
    status: this.fields.status.control.valueChanges
    ,
    reason_codes: this.fields.reason_codes.control.valueChanges
    ,
  }
  

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: Lots_ShellService,
    private $datasources: Lots_DatasourceService,
    private $flows: Lots_FlowService,
    private $reports: Lots_ReportService,
    private $localization: Lots_LocalizationService,
    private $operations: Lots_OperationService,
    private $logger: CleanupLoggerService,
    private $context: Lots_lot_status_change_editor_ComponentContextService,
    ) { 
    super();
    this.$subscribeFormControlValueChanges();
    
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }
  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.lotId)) {
        this.$missingRequiredInParams.push('lotId');
      }
  }

  initialized = false;

  $hasDataLoaded = false;

  async $init() {
    this.title = 'Edit lot status';
    
    await this.on_init();

    await this.$dataLoad();
    this.initialized = true;
  }

  async $dataLoad() {
    const $editor = this;
    const $utils = this.$utils;

    const dsParams = {
      lotId:  $editor.inParams.lotId 
    };

    const data = await this.$datasources.Lots.ds_lot_editor.get(dsParams);

    if (isNil(data.result)) {
      this.$hasDataLoaded = false;
      this.entity = null;
    } else {
      this.$hasDataLoaded = true;

      await this.$applyLinkedDatasourcesAndCustomColumns(dsParams, data);
      
      this.entity = data.result as EntityType;

      await this.$dataLoaded();
    }
  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  async $dataLoaded() {
    const $editor = this;
    const $utils = this.$utils;
   
    (this.fields.status.control as SelectBoxModel).reset($editor.entity.StatusId);

  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();
    
    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
  }

  close() {
    this.$finish.emit();
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }
  
  private $subscribeFormControlValueChanges() {
    this.$formGroupFieldValidationObservables
      .status
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_status_change();
      });
    this.$formGroupFieldValidationObservables
      .reason_codes
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
  }

  //#region private flows
  on_cancel_clicked(event = null) {
    return this.on_cancel_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_cancel_clickedInternal(
    $editor: Lots_lot_status_change_editorComponent,
  
    $shell: Lots_ShellService,
    $datasources: Lots_DatasourceService,
    $flows: Lots_FlowService,
    $reports: Lots_ReportService,
    $settings: SettingsValuesService,
    $operations: Lots_OperationService,
    $utils: UtilsService,
    $context: Lots_lot_status_change_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Lots_LocalizationService,
    $event: any
  ) {
  $editor.outParams.confirm = false;
  $editor.close();
  }
  on_confirm_clicked(event = null) {
    return this.on_confirm_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_confirm_clickedInternal(
    $editor: Lots_lot_status_change_editorComponent,
  
    $shell: Lots_ShellService,
    $datasources: Lots_DatasourceService,
    $flows: Lots_FlowService,
    $reports: Lots_ReportService,
    $settings: SettingsValuesService,
    $operations: Lots_OperationService,
    $utils: UtilsService,
    $context: Lots_lot_status_change_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Lots_LocalizationService,
    $event: any
  ) {
  $editor.toolbar.confirm.control.readOnly = true;
  let payload: any = {};
  
  
  
  
  if ($editor.fields.status.control.isChanged) {
      payload.StatusId = $editor.fields.status.control.value;
  
      const currentStatus = (await $datasources.Lots.ds_get_status_by_statusId.get({ statusId: $editor.entity.StatusId })).result;
      var currentStatusName = currentStatus.Name;
  
      const updatedStatus = (await $datasources.Lots.ds_get_status_by_statusId.get({ statusId: $editor.fields.status.control.value })).result;
      var updatedStatusName = updatedStatus.Name;
  }
  
  
  
  try {
  
      if ($editor.fields.status.control.isChanged) {
  
          let statusId = $editor.fields.status.control.value;
          let reasonCodeIds = $editor.fields.reason_codes.control.value;
  
          let status_change = (await $flows.Lots.update_lot_status({ lotId: $editor.entity.Id, statusId: statusId, reasonCodeIds: reasonCodeIds }));
  
          let reason: string;
  
          if (!$utils.isDefined(status_change.lotId)) {
  
              if ($utils.isDefined(status_change.reason)) {
                  reason = status_change.reason;
              } else {
                  reason = "Uncaught exception updating the status of the lot.";
              };
  
          } else {
              if (status_change.lotId !== $editor.entity.Id) {
                  reason = "Uncaught exception updating the status of the lot! The lot id returned does not match the lot supplied.";
              };
          };
  
          if ($utils.isDefined(reason)) {
              if (reason !== "") {
                  throw reason;
              };
          };
  
  
      };
  
      await $flows.Utilities.crud_update_flow({ entitySet: 'Lots', id: $editor.entity.Id, entity: payload });
  
  
      $editor.outParams.confirm = true;
      $editor.close();
  
  }
  
  catch (error) {
      $editor.toolbar.confirm.control.readOnly = false;
      $shell.Lots.showErrorDetails('Save', 'Error on save.', error);
      throw error; // to prevent displayMode 
  };
  
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $editor: Lots_lot_status_change_editorComponent,
  
    $shell: Lots_ShellService,
    $datasources: Lots_DatasourceService,
    $flows: Lots_FlowService,
    $reports: Lots_ReportService,
    $settings: SettingsValuesService,
    $operations: Lots_OperationService,
    $utils: UtilsService,
    $context: Lots_lot_status_change_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Lots_LocalizationService,
    $event: any
  ) {
  $editor.outParams.confirm = false;
  $editor.fields.reason_codes.hidden = true;
  
  const lot = (await $datasources.Lots.ds_get_lot_by_lotId.get({lotId: $editor.inParams.lotId})).result[0].LookupCode;;
  
  $editor.title = `Change status for lot ${lot}?`;
  }
  on_status_change(event = null) {
    return this.on_status_changeInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_status_changeInternal(
    $editor: Lots_lot_status_change_editorComponent,
  
    $shell: Lots_ShellService,
    $datasources: Lots_DatasourceService,
    $flows: Lots_FlowService,
    $reports: Lots_ReportService,
    $settings: SettingsValuesService,
    $operations: Lots_OperationService,
    $utils: UtilsService,
    $context: Lots_lot_status_change_editor_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Lots_LocalizationService,
    $event: any
  ) {
  //O.Arias - 09/11/2023
  
  if ($editor.fields.status.control.isChanged) {
      $editor.fields.reason_codes.hidden = false;
  };
  }
  //#endregion private flows
  
}
